import React, { useContext } from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Container } from 'react-bootstrap';
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import EditIcon from '@mui/icons-material/Edit';
import CodeIcon from '@mui/icons-material/Code';
import { AuthContext } from "../../helpers/AuthContext";
import AppInstanceList from "../essentials/AppInstanceList";
import NoDataContainer from "../../components/NoDataContainer";
import MessageIcon from '@mui/icons-material/Message';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import PageHeaderWithBreadcrumbs from "../../components/PageHeaderWithBreadcrumbs";
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import HomeIcon from '@mui/icons-material/Home';
import SubjectIcon from '@mui/icons-material/Subject';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import InvoicesTable from "../../components/InvoicesTable";
import MainDashboardLeftSidebar from "../essentials/MainDashboardLeftSidear"


/* REMOVE material-ui node module */

function InvoicesManager(props) {
  const [listOfInvoices, setListOfInvoices] = useState([]);
  const { authState } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  let history = useHistory();

  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      history.push("/login");
    } else {
      axios
      .get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/auth`, {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      }).then((authResponse) => {
      axios
        .get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/invoices/byuserId/${authResponse.data.id}`, {
          headers: { accessToken: localStorage.getItem("accessToken") },
        })
        .then((response) => {
          setListOfInvoices(response.data.listOfInvoices);
          setLoading(false)
        });
      })
    }
  }, [authState.id]);

  return (
    <div className="ec-app-instances">
      <MainDashboardLeftSidebar/>
      <div className="rightSide">
        { loading == false ?
        listOfInvoices && listOfInvoices.length ?
          <div className="options-container fade-in-effect-usability">
            <div className="options-inner-container">
          <h1 className="main-page-heading">Manage your invoices</h1>
            <span className="main-page-description">You have {listOfInvoices.length} total invoices.</span>
          <InvoicesTable listOfInvoices={listOfInvoices}/>
          </div>
          </div>

          : 

          <div className="options-container fade-in-effect-usability">
          <div className="options-inner-container">
            <div className="options options-no-header-or-footer">
              <h2>No invoices</h2>
              <p>You don't have any previous invoices.</p>
            </div>
          </div>
        </div>   

          : "" } 
        </div>
    </div>
  );
}

export default InvoicesManager;
